import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useSelectedCamera } from "@/context/selected-camera-context";
import CameraDetail from "@/cameras/camera-detail";
import Cameras from "@/cameras/cameras";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useLocalization } from "@/context/localization-context";

export default function Page() {
  const { t } = useLocalization();
  const { deviceId } = useParams();
  const { selectedDeviceId, setSelectedDeviceId } = useSelectedCamera();

  useEffect(() => {
    setSelectedDeviceId(deviceId || null);
  }, [deviceId, setSelectedDeviceId]);

  return (
    <div className="app-layout grid grid-cols-1 2xl:grid-cols-1 gap-4 p-4">
      {selectedDeviceId && (
        <CameraDetail />
      )}
      <div>
        <Card className="">
          <CardHeader>
            <CardTitle>{t("cameras.page.title")}</CardTitle>
          </CardHeader>
          <CardContent>
            <Cameras getLink={(deviceId) => `/cameras/${deviceId}`} />
          </CardContent>
        </Card>
      </div>

    </div>
  );
}